import { makeMainUrl } from '../../../shared/util/url';
import { unEscaper } from '@modules/Util/S/Function/util';

type TSearchResultTabId = 'all' | 'product' | 'creator' | 'popup_store' | 'plus_shop' | 'curation';

/**
 * 검색 결과 페이지의 url을 반환합니다.
 */
export const generateSearchUrl = (search: string, tab?: TSearchResultTabId): string => {
  const encodedSearch = encodeURIComponent(unEscaper(search));

  let path = `/${ET.lang}/@/search?keyword=${encodedSearch}`;

  if (tab === 'all') {
    path += '&tab=all';
  } else if (tab === 'plus_shop') {
    path += '&tab=plus_shop';
  } else if (tab === 'curation') {
    path += '&tab=curation';
  } else if (tab === 'popup_store') {
    path += '&tab=popup_store';
  } else if (tab === 'product') {
    path += '&tab=product';
  } else if (tab === 'creator') {
    path += '&tab=creator';
  } else {
    // default
    path += '&tab=all';
  }

  return makeMainUrl(path);
};

export const generateCreatorShopSearchUrl = (search: string, domain_name: string): string => {
  return makeMainUrl(`/${ET.lang}/${domain_name}/search?keyword=${encodeURIComponent(unEscaper(search))}`);
};
